// extracted by mini-css-extract-plugin
module.exports = {"force-set-pass-dialog":"ForceSetPassword_force-set-pass-dialog__1Xpd8"};